const LOG_PREFIX = "[OCM][Custom] "
let customCode = (utils) => {
   return new Promise((resolve, reject) => {
       resolve(true)
   });
};
module.exports = customCode;

/** Copy paste from v1 (everything is disabled now) **/

// // Re-enable when it's on a proper domain
// // (function(w, d) {
// //   try {
// //     d = w.top.document || d; w = w.top.document ? w.top : w;
// //   } catch (e) {}
// //   var ttag = function() {
// //     w.teads.page(118445).placement(128519, {slider: {allow_corner_position: false, allow_top_position: false}, "css":"margin: 0px auto;  max-width: 650px;","format":"inread","slot":{"selector":"#outstream-banner","minimum":1}}).serve();
// //   };
// //   if (w.teads && w.teads.page) { ttag(); }
// //   else if (!w.teadsscript) {
// //     var s = document.createElement('script');
// //     s.src = 'https://s8t.teads.tv/media/format/v3/teads-format.min.js';
// //     s.async = true; s.onload = ttag; w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
// //   } else {
// //     w.teadsscript.addEventListener('load', ttag);
// //   }
// // })(window, document);

// var multiplex_trigger_el = null;

// function initMultiplex() {
//   var selector = document.querySelector('#multiplex-parent');
//   if (selector) {
//     var fixed_width = selector.offsetWidth;
//     // selector.parentNode.style.width = fixed_width + 'px';
//     var multiplex_slot = null;
//     // Create multiplex div with googletag script inside
//     // var define_script = document.createElement('script');
//     // define_script.text = 'googletag.cmd.push(function() { multiplex_slot = googletag.defineSlot(\'/75351959/pronews.gr/multiplex\', \'fluid\', \'multiplex-div\').addService(googletag.pubads()); });';
//     selector.style.width = fixed_width + 'px';
//     var multiplex_div = document.createElement('div');
//     multiplex_div.id = 'multiplex-div';
//     multiplex_div.style.width = fixed_width + 'px';
//     var multiplex_script = document.createElement('script');
//     multiplex_script.text = 'googletag.cmd.push(function() { multiplex_slot = googletag.defineSlot(\'/75351959/whoscored.com/multiplex\', \'fluid\', \'multiplex-div\').addService(googletag.pubads()); googletag.display(\'multiplex-div\'); /*googletag.pubads().refresh([multiplex_slot]);*/ });';

//     // selector.appendChild(define_script);
//     selector.appendChild(multiplex_div);
//     multiplex_div.appendChild(multiplex_script);

//     if ("orientationchange" in window) {
//       window.addEventListener("orientationchange", function() {
//         googletag.cmd.push(function() {
//           var fixed_width = selector.offsetWidth;
//           selector.style.width = fixed_width + 'px';
//           multiplex_div.style.width = fixed_width + 'px';

//           googletag.pubads().refresh([multiplex_slot]);
//         });
//       });
//     }
//   }
// }

// (function () {
//   if (ocm_is_mobile) {
//     if (/loaded|complete|interactive/.test(document.readyState)) {
//       // initMultiplex();
//       // if (!ocmGetParameterByName('vi_demo')) {
//       //   initVR();
//       // }
//     } else {
//       document.addEventListener('DOMContentLoaded', function () {
//         // initMultiplex();
//         // if (!ocmGetParameterByName('vi_demo')) {
//         // initVR();
//         // }
//       });
//     }
//   }
// })();

// function initVR() {
//   return;
//   // if (!ocmGetParameterByName('vi_demo')) {
//   // return;
//   // }

//   // if (window.outerWidth <= 1304) {
//   //   return;
//   // }

//   if (window.location.hostname === '1xbet.whoscored.com' || window.location.hostname === 'ru.whoscored.com') {
//     return;
//   }

//   ocmLoadStyle('#vi-stories-sponsor-container {display: none!important;}');

//   var slot = null;

//   if (!ocm_is_mobile) {
//     slot = document.querySelectorAll('.sticky-unit-container')[0];
//   } else {
//     slot = document.querySelectorAll('#home-editorial, #live-incidents, #previous-meetings-container')[0];
//   }

//   var vidiv = document.createElement('div');
//   vidiv.id = 'vi-div';
//   vidiv.style.margin = '0 auto';

//   if (slot) {
//     slot.appendChild(vidiv);
//   }

//   googletag.cmd.push(function () {
//     googletag.pubads().addEventListener('slotRenderEnded', function (e) {
//       if (e.slot.getAdUnitPath() === '/79450181/whoscored.com/mobile_sticky' && !e.isEmpty) {
//         ocmLoadStyle('.vi-stories-floating {margin-bottom: 100px!important;}');
//       }
//     });
//   });

//   (function (v, i) {
//     var scp = v.createElement("script"),
//         config = {
//           ChannelID: '5d8390ef28a0611e523a52aa',
//           AdUnitType: '2',
//           PublisherID: '133044126840134',
//           PlacementID: 'pltz9FljnNNm8YU6PEn',
//           DivID: 'vi-div',
//           IAB_Category: 'IAB1',
//           Keywords: '',
//           Language: 'en-us',
//           BG_Color: '',
//           Text_Color: '',
//           Font: '',
//           FontSize: '',
//         };
//     scp.src = 'https://s.vi-serve.com/tagLoader.js';
//     scp.type = "text/javascript";
//     scp.onload = function () {
//       i[btoa('video intelligence start')].init(config);
//     };
//     (v.getElementsByTagName('head')[0] || v.documentElement.appendChild(v.createElement('head'))).appendChild(scp);
//   })(document, window);
// }